import {
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Box,
} from '@chakra-ui/react'
import FirestoreUser from '../../../../types/FirestoreUser'
import usePurpleBubblesText from '../../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../../components/PurpleBubbleContent'
import { useEnvironmentalData, useEnvironmentalSave } from './hooks'
import { ConditionSection, SaveButton } from './components'
import {
  moldConditions,
  heavyMetalConditions,
  petroleumConditions,
  pesticideConditions,
  chemicalConditions,
  plasticConditions,
  militaryConditions,
  geopathicConditions,
  emfConditions,
  radiationConditions,
  carbonMonoxideConditions,
} from './utils'

interface Props {
  uid: string
  firestoreUser: FirestoreUser
}

const EnvironmentalTab = ({ uid, firestoreUser }: Props) => {
  const {
    exposureHistory,
    setExposureHistory,
    userAge,
  } = useEnvironmentalData({ uid, firestoreUser })

  const { isSaving, saveExposureHistory } = useEnvironmentalSave(uid)
  const purpleBubbleContent = usePurpleBubblesText('Profile-step-4')

  return (
    <form>
      {purpleBubbleContent?.text && (
        <PurpleBubbleContent text={purpleBubbleContent.text} />
      )}
      
      <Box mb={4} mt={4}>
        <SaveButton
          isSaving={isSaving}
          onClick={saveExposureHistory}
          exposureData={exposureHistory}
          fieldName="exposureHistory"
        />
      </Box>
      
      <Table variant="simple" mt={4}>
        <Thead>
          <Tr>
            <Th textAlign="left">Known Toxic Exposures</Th>
            <Th textAlign="left">Have/had exposure</Th>
            <Th textAlign="left">Age at start of exposure</Th>
            <Th textAlign="left">Age at end of exposure (Blank if current)</Th>
            <Th textAlign="left">Estimated total years</Th>
          </Tr>
        </Thead>
        <Tbody>
          <ConditionSection
            title="Mold and Mycotoxins in home or work"
            conditions={moldConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Heavy Metals"
            conditions={heavyMetalConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Petroleum/Gasoline/Diesel"
            conditions={petroleumConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Pesticides"
            conditions={pesticideConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Chemicals, Solvents and more"
            conditions={chemicalConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Plastics"
            conditions={plasticConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Military Exposure"
            conditions={militaryConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Geopathic fields"
            conditions={geopathicConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Known EMF exposure"
            conditions={emfConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Radiation Exposure"
            conditions={radiationConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
          <ConditionSection
            title="Carbon Monoxide"
            conditions={carbonMonoxideConditions}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
        </Tbody>
      </Table>
      
      <Box mb={4} mt={4}>
        <SaveButton
          isSaving={isSaving}
          onClick={saveExposureHistory}
          exposureData={exposureHistory}
          fieldName="exposureHistory"
        />
      </Box>
    </form>
  )
}

export default EnvironmentalTab